import styled from 'styled-components';

export const Container = styled.div`
  border: 1px var(--color-border) solid;
  border-radius: 4px;
  margin-top: 8px;
  padding: 8px;
`;
